import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/axelerate-logo-purple.svg'
import _imports_1 from '@/assets/ilustration-sent.svg'
import _imports_2 from '@/assets/ilustration-forgot.svg'


const _hoisted_1 = { class: "bg-background min-h-screen" }
const _hoisted_2 = { class: "flex justify-center items-center min-h-screen" }
const _hoisted_3 = { class: "flex flex-col bg-white shadow rounded-2xl w-1/2 xl:w-1/3 p-14" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-2/5"
}, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col mt-8"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-1/2"
}, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col mt-8"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold" }, "New password", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "pt-4" }, " Your new password must be different from one you have used before. ", -1)
const _hoisted_10 = { class: "flex flex-col mt-4" }
const _hoisted_11 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, " Password must contain one UPPERCASE letter, one lowercase letter, and one special character. ", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, " Passwords must match. ", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 2,
  class: "mt-4"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, " Something went wrong, please try again. ", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "flex flex-col mt-8"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold" }, "Password succesfully changed!", -1)
const _hoisted_22 = {
  key: 1,
  class: "flex flex-col mt-8"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "w-1/2"
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col mt-8" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold" }, "No token found")
], -1)
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (!_ctx.errors.token)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              (_ctx.step === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _hoisted_8,
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.passwords.password) = $event)),
                        type: "password",
                        class: "apperance-none border-0 rounded bg-gray-100 p-4 mt-4 focus:bg-white focus:outline-none focus:ring-2 focus:ring-black",
                        placeholder: "New password"
                      }, null, 512), [
                        [_vModelText, _ctx.passwords.password]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.passwords.confirmation) = $event)),
                        type: "password",
                        class: "apperance-none border-0 rounded bg-gray-100 p-4 mt-4 focus:bg-white focus:outline-none focus:ring-2 focus:ring-black",
                        placeholder: "Confirm new password"
                      }, null, 512), [
                        [_vModelText, _ctx.passwords.confirmation]
                      ]),
                      (_ctx.errors.validation)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                        : _createCommentVNode("", true),
                      (_ctx.errors.matching)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
                        : _createCommentVNode("", true),
                      (_ctx.errors.api)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setNewPassword && _ctx.setNewPassword(...args))),
                      class: "w-full text-white bg-primary rounded-full py-4 mt-8"
                    }, " Save new password ")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.step === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("button", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/login'))),
                      class: "text-primary mt-8"
                    }, " Log In ")
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_25))
      ])
    ])
  ]))
}